export const CATEGORY_CSS = `
  .arc-page {
    background: var(--color-white);
    min-height: 100vh;
  }

  /* ── Hero ── */
  .arc-hero {
    position: relative;
    height: 38vh;
    min-height: 260px;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    background: var(--color-midnight);
  }
  .arc-hero__bg {
    position: absolute; inset: 0;
  }
  .arc-hero__bg img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    opacity: 0.45;
  }
  .arc-hero__overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to top,
      rgba(7,30,48,0.92) 0%,
      rgba(7,30,48,0.4)  60%,
      rgba(7,30,48,0.1)  100%
    );
  }
  .arc-hero__content {
    position: relative; z-index: 2;
    padding: 0 6vw 40px;
    width: 100%;
    max-width: 1200px;
  }
  .arc-hero__eyebrow {
    display: block;
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.2em; text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 8px;
  }
  .arc-hero__title {
    font-family: var(--font-serif);
    font-size: clamp(2.4rem, 5vw, 4rem);
    font-weight: 300;
    color: var(--color-ivory);
    margin: 0;
    line-height: 1.1;
  }

  /* ── Filter bar ── */
  .arc-filter {
    border-bottom: 1px solid var(--color-divider);
    background: var(--color-white);
    position: sticky; top: 0; z-index: 10;
  }
  .arc-filter__inner {
    max-width: 1200px; margin: 0 auto;
    padding: 0 6vw;
    display: flex; gap: 0;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .arc-filter__inner::-webkit-scrollbar { display: none; }
  .arc-filter__btn {
    background: none; border: none;
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--color-slate);
    padding: 16px 20px 14px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
    transition: color 0.2s, border-color 0.2s;
  }
  .arc-filter__btn:hover { color: var(--color-teal); }
  .arc-filter__btn--active {
    color: var(--color-teal);
    border-bottom-color: var(--color-teal);
  }

  /* ── Main grid ── */
  .arc-main {
    max-width: 1200px; margin: 0 auto;
    padding: 60px 6vw 80px;
  }
  .arc-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px 24px;
  }
  @media (max-width: 860px) {
    .arc-grid { grid-template-columns: repeat(2, 1fr); gap: 24px 16px; }
  }
  @media (max-width: 540px) {
    .arc-grid { grid-template-columns: 1fr; gap: 20px; }
  }

  /* ── Card ── */
  .arc-card {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
  }
  .arc-card__thumb {
    position: relative;
    aspect-ratio: 16 / 10;
    overflow: hidden;
    margin-bottom: 16px;
    background: var(--color-ivory);
  }
  .arc-card__thumb img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    transition: transform 0.55s ease;
  }
  .arc-card:hover .arc-card__thumb img { transform: scale(1.05); }
  .arc-card__thumb-mock {
    width: 100%; height: 100%;
    display: flex; align-items: center; justify-content: center;
  }
  .arc-card__thumb-svg {
    width: 84px; height: auto;
    color: rgba(255,255,255,0.52);
  }
  .arc-card__cat {
    position: absolute; top: 12px; left: 12px;
    font-family: var(--font-sans);
    font-size: 9px; font-weight: 500;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--color-ivory);
    background: var(--color-teal);
    padding: 3px 9px;
  }
  .arc-card__body {
    padding: 0 2px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .arc-card__meta {
    display: flex; align-items: center; gap: 5px;
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 8px;
  }
  .arc-card__title {
    font-family: var(--font-serif);
    font-size: clamp(1.15rem, 2vw, 1.4rem);
    font-weight: 400;
    color: var(--color-charcoal);
    margin: 0 0 10px;
    line-height: 1.35;
    transition: color 0.2s;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .arc-card:hover .arc-card__title { color: var(--color-teal); }
  .arc-card__excerpt {
    font-family: var(--font-sans);
    font-size: 13px; font-weight: 300;
    line-height: 1.65;
    color: var(--color-slate);
    margin: 0 0 14px;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .arc-card__cta {
    display: inline-flex; align-items: center; gap: 5px;
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: var(--color-teal);
    border-bottom: 1px solid var(--color-teal-divider);
    padding-bottom: 2px;
    transition: gap 0.2s, border-color 0.2s;
  }
  .arc-card:hover .arc-card__cta {
    gap: 9px;
    border-color: var(--color-teal);
  }

  /* ── Empty state ── */
  .arc-empty {
    text-align: center;
    padding: 80px 0;
    font-family: var(--font-sans);
    font-size: 14px;
    color: var(--color-slate);
    letter-spacing: 0.05em;
  }

  /* ── Load More ── */
  .arc-loadmore {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 64px;
  }

  .arc-loadmore__btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 14px;
    background: none;
    border: 1px solid var(--color-teal);
    color: var(--color-teal);
    font-family: var(--font-sans);
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    padding: 14px 36px;
    cursor: pointer;
    transition: background 0.25s, color 0.25s;
    min-width: 180px;
    justify-content: center;
  }

  .arc-loadmore__btn:hover:not(:disabled) {
    background: var(--color-teal);
    color: #fff;
  }

  .arc-loadmore__btn:hover .arc-loadmore__line {
    width: 28px;
    background: #fff;
  }

  .arc-loadmore__btn:disabled {
    cursor: default;
  }

  .arc-loadmore__line {
    display: inline-block;
    width: 18px;
    height: 1px;
    background: var(--color-teal);
    transition: width 0.25s, background 0.25s;
  }

  /* Spinner */
  .arc-loadmore__spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1.5px solid rgba(31,111,95,0.25);
    border-top-color: var(--color-teal);
    border-radius: 50%;
    animation: arc-spin 0.7s linear infinite;
  }

  @keyframes arc-spin {
    to { transform: rotate(360deg); }
  }

  /* End of list */
  .arc-loadmore--end {
    gap: 20px;
  }

  .arc-loadmore__end-line {
    flex: 1;
    max-width: 120px;
    height: 1px;
    background: var(--color-divider);
  }

  .arc-loadmore__end-text {
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--color-slate);
    white-space: nowrap;
  }
`
